var r = function (r) {
  return r.reduce(function (r, t, n) {
    return r + ("string" == typeof t ? (n > 0 ? "." : "") + t : "[" + t + "]");
  }, "").toString();
};
export { r as convertArrayToPathName };